/**
 * Autore: Salvo de Luca
 * Azienda: Dialogicom s.r.l.s.
 * File: src/components/modular-form/custom/PrivacyLinks.tsx
 * Release: v1.0.0
 * Data: 28/05/2025
 * Componente per i link alla privacy policy e terms of service
 */

import React from 'react';
import { ExternalLink } from 'lucide-react';

interface PrivacyLinksProps {
  disabled?: boolean;
}

export const PrivacyLinks: React.FC<PrivacyLinksProps> = ({
  disabled = false
}) => {
  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open('/privacy-policy.html', '_blank');
  };

  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open('/terms-of-service.html', '_blank');
  };

  return (
    <div className="flex flex-col space-y-2 text-sm text-zinc-400">
      <div className="flex items-center space-x-2">
        <span>Leggi la nostra</span>
        <button
          type="button"
          onClick={handlePrivacyClick}
          disabled={disabled}
          className="inline-flex items-center space-x-1 text-blue-400 hover:text-blue-300 underline transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span>Privacy Policy</span>
          <ExternalLink size={12} />
        </button>
        <span>e i nostri</span>
        <button
          type="button"
          onClick={handleTermsClick}
          disabled={disabled}
          className="inline-flex items-center space-x-1 text-blue-400 hover:text-blue-300 underline transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span>Termini di Servizio</span>
          <ExternalLink size={12} />
        </button>
      </div>
      <p className="text-xs text-zinc-500">
        Cliccando sui link sopra, accetti il trattamento dei tuoi dati personali secondo la nostra Privacy Policy.
      </p>
    </div>
  );
}; 